(function() {
    'use strict';

    if (window.__NEPDPDiscountPriceStableV2) return;
    window.__NEPDPDiscountPriceStableV2 = true;

    var currentSignature = '';
    var updateTimer = null;
    var subscriptionBaseCents = null;

    function normalizeCode(code) {
      return String(code || '').trim().toUpperCase();
    }

    function isSubscriptionActive() {
      return !!document.querySelector('.subscription-option--abo.subscription-option--active');
    }

    function getDiscountDetails() {
      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.getDetails === 'function'
      ) {
        try {
          var details = window.NE.DiscountTracker.getDetails();

          if (details && details.code) {
            return {
              code: normalizeCode(details.code),
              percentage: Number(details.percentage || 0)
            };
          }
        } catch (e) {}
      }

      try {
        var cached = sessionStorage.getItem('ne_discount_details');

        if (cached) {
          var parsed = JSON.parse(cached);

          if (parsed && parsed.code) {
            return {
              code: normalizeCode(parsed.code),
              percentage: Number(parsed.percentage || 0)
            };
          }
        }
      } catch (e) {}

      try {
        var storedCode = sessionStorage.getItem('ne_discount_code');

        if (storedCode) {
          return {
            code: normalizeCode(storedCode),
            percentage: 0
          };
        }
      } catch (e) {}

      return null;
    }

    function getPriceElement() {
      return document.querySelector('.product__price-wrapper--compare-price span[data-price]');
    }

    function formatPrice(price) {
      return window.NE.Utils.formatMoney(Math.round(Number(price || 0) * 100));
    }

    function getBasePrice(priceElement) {
      if (
        isSubscriptionActive() &&
        subscriptionBaseCents !== null &&
        Number(subscriptionBaseCents) > 0
      ) {
        return Number(subscriptionBaseCents) / 100;
      }

      var priceValue = priceElement ? priceElement.getAttribute('data-price') : null;
      if (!priceValue) return 0;

      return parseFloat(String(priceValue).replace(',', '.')) || 0;
    }

    function restorePrice(priceElement) {
      if (!priceElement) return;

      if (priceElement.hasAttribute('data-shopify-original-html')) {
        priceElement.innerHTML = priceElement.getAttribute('data-shopify-original-html');
        priceElement.removeAttribute('data-shopify-original-html');
        priceElement.removeAttribute('data-ne-pdp-discount-price');
      }

      currentSignature = '';
    }

    function renderPrice(priceElement, percentage, code) {
      if (!priceElement || !percentage || percentage <= 0) {
        restorePrice(priceElement);
        return;
      }

      var originalPrice = getBasePrice(priceElement);
      if (!originalPrice || isNaN(originalPrice)) return;

      if (!priceElement.hasAttribute('data-shopify-original-html')) {
        priceElement.setAttribute('data-shopify-original-html', formatPrice(originalPrice));
      }

      var discountedPrice = originalPrice - (originalPrice * percentage / 100);
      var signature = normalizeCode(code) + '|' + originalPrice + '|' + percentage + '|' + (isSubscriptionActive() ? 'sub' : 'normal');

      if (
        signature === currentSignature &&
        priceElement.getAttribute('data-ne-pdp-discount-price') === 'true'
      ) {
        return;
      }

      currentSignature = signature;

      priceElement.innerHTML =
        '<span class="ne-discount-price-wrapper">' +
          '<span class="ne-discount-price__discounted">' + formatPrice(discountedPrice) + '</span>' +
          '<span class="ne-discount-price__original">' + formatPrice(originalPrice) + '</span>' +
        '</span>';

      priceElement.setAttribute('data-ne-pdp-discount-price', 'true');
    }

    function updatePDPPrice() {
      if (!document.body.classList.contains('template-product')) return;

      var priceElement = getPriceElement();
      if (!priceElement) return;

      var details = getDiscountDetails();

      if (!details || !details.code) {
        restorePrice(priceElement);
        return;
      }

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.fetchProductDiscount === 'function' &&
        window.meta &&
        window.meta.product &&
        window.meta.product.id
      ) {
        window.NE.DiscountTracker.fetchProductDiscount(details.code, window.meta.product.id)
          .then(function(percentage) {
            percentage = Number(percentage || 0);

            if (percentage > 0) {
              renderPrice(priceElement, percentage, details.code);
            } else {
              restorePrice(priceElement);
            }
          })
          .catch(function() {
            restorePrice(priceElement);
          });
      } else {
        restorePrice(priceElement);
      }
    }

    function scheduleUpdate(delay) {
      clearTimeout(updateTimer);

      updateTimer = setTimeout(function() {
        requestAnimationFrame(updatePDPPrice);
      }, typeof delay === 'number' ? delay : 120);
    }

    function init() {
      if (!document.body.classList.contains('template-product')) return;

      scheduleUpdate(200);

      window.addEventListener('ne:discount-code-updated', function() {
        currentSignature = '';
        scheduleUpdate(250);
      });

      window.addEventListener('ne:discount-details-updated', function() {
        currentSignature = '';
        scheduleUpdate(250);
      });

      document.addEventListener('discount:updated', function() {
        currentSignature = '';
        scheduleUpdate(250);
      });

      document.addEventListener('subscription:changed', function(event) {
        if (
          event.detail &&
          event.detail.subscriptionPlanId &&
          event.detail.finalPriceCents
        ) {
          subscriptionBaseCents = Number(event.detail.finalPriceCents || 0);
        } else {
          subscriptionBaseCents = null;
        }

        currentSignature = '';

        var priceElement = getPriceElement();
        if (priceElement) {
          priceElement.removeAttribute('data-shopify-original-html');
          priceElement.removeAttribute('data-ne-pdp-discount-price');
        }

        scheduleUpdate(80);
      });

      window.addEventListener('ne:discount-code-cleared', function() {
        restorePrice(getPriceElement());
      });

      var priceElement = getPriceElement();

      if (priceElement) {
        var observer = new MutationObserver(function(mutations) {
          var shouldUpdate = false;

          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-price') {
              shouldUpdate = true;
            }
          });

          if (shouldUpdate) {
            currentSignature = '';
            scheduleUpdate(120);
          }
        });

        observer.observe(priceElement, {
          attributes: true,
          attributeFilter: ['data-price']
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
      })();
